import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=894c9b42&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=894c9b42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports